import apiPaths from '../api-paths.js';

export default {
  index({ query }) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/evidence-description-template${ query }`);
  },
  search({ search }) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/evidence-description-template/search`, { search });
  },
  show({ id }) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/evidence-description-template/${ id }`);
  },
  store({ evidenceDescriptionTemplate }) {
    return axios.post(
      `${ apiPaths.BOOKKEEPING }/evidence-description-template`,
      { evidencedescriptiontemplate: evidenceDescriptionTemplate },
    );
  },
  update({ evidenceDescriptionTemplate }) {
    return axios.put(
      `${ apiPaths.BOOKKEEPING }/evidence-description-template/${ evidenceDescriptionTemplate.id }`,
      { evidencedescriptiontemplate: evidenceDescriptionTemplate },
    );
  },
  destroy({ id }) {
    return axios.delete(`${ apiPaths.BOOKKEEPING }/evidence-description-template/${ id }`);
  },
  import({ file }) {
    const formData = new FormData();
    formData.append('file', file);

    const headers = { 'Content-Type': 'multipart/form-data' };

    return axios.post(`${ apiPaths.BOOKKEEPING }/evidence-description-template/import/optima`, formData, headers);
  },
};
